import React from 'react';
import './KPICard.scss';

interface KPICardProps {
  icon: string | React.ReactNode;
  iconColor?: 'navy' | 'red' | 'gold' | 'green' | 'amber';
  value: string | number;
  label: string;
  trend?: {
    value: string;
    type: 'up' | 'down' | 'warn' | 'alert' | 'neutral';
  };
  animate?: boolean;
  animateDelay?: number;
  onClick?: () => void;
}

const KPICard: React.FC<KPICardProps> = ({
  icon,
  iconColor = 'navy',
  value,
  label,
  trend,
  animate = true,
  animateDelay = 0,
  onClick
}) => {
  const cardClasses = [
    'kpi-card',
    animate && 'animate-fadeUp',
    onClick && 'kpi-card--clickable'
  ].filter(Boolean).join(' ');

  const trendClasses = trend ? `kpi-trend kpi-trend--${trend.type}` : '';

  const style = animate && animateDelay ? { animationDelay: `${animateDelay}s` } : {};

  return (
    <div className={cardClasses} style={style} onClick={onClick}>
      <div className="kpi-card__top">
        <div className={`kpi-card__icon kpi-card__icon--${iconColor}`}>
          {typeof icon === 'string' ? <span>{icon}</span> : icon}
        </div>
        {trend && (
          <span className={trendClasses}>
            {trend.type === 'up' && '↑ '}
            {trend.type === 'down' && '↓ '}
            {trend.value}
          </span>
        )}
      </div>
      <div className="kpi-card__value">{value}</div>
      <div className="kpi-card__label">{label}</div>
    </div>
  );
};

export default KPICard;